document.addEventListener("turbolinks:load", function (e) {
    let $dashboard = $('#dashboard');

    if ($dashboard.length > 0) {
        $('.dashboard_menu_dir').on('show.bs.collapse', function () {
            $(this).prev().find('.dir_arrow').toggleClass('d-none');
        })
        $('.dashboard_menu_dir').on('hide.bs.collapse', function () {
            $(this).prev().find('.dir_arrow').toggleClass('d-none');
        })
    }
});